import { Inline, Stack, Text } from '@front10/base-elements';
import * as React from 'react';
import { PassengerProps } from './PeopleCounter';
import { useTranslation } from '@front10/utils';
import nanoid from 'nanoid';
import { Listbox } from '../Select';
const styles = {
  grow: {
    flex: 1,
    flexWrap: 'wrap'
  }
} as const;

interface PeopleAgePickerProps {
  config: PassengerProps;
  updateFocusAction?: () => void;
  ages: number[];
  popoverRef?: any;
  onChange?: (index: number, value: number) => void;
  filterContentRef?: React.RefObject<HTMLDivElement>;
  doNotClosePopup?: () => void;
}

export function PeopleAgePicker(props: PeopleAgePickerProps) {
  const translate = useTranslation();
  const config = props.config;
  const ages = props.ages;
  const [id] = React.useState(nanoid());

  if (config.shouldDetailAges && ages.length > 0) {
    const ageRanges = Array(config.maxAge - config.minAge + 1)
      .fill(0)
      .map((_, index) => {
        const age = `${config.minAge + index}`;
        if (config.showDetailedAgeOptions || config.allowInfantCustomLabel) {
          if (age === '0') {
            return {
              value: age,
              label: translate('cmp-booking-mask-label-infant-lap', '0-1 Infant in lap')
            };
          } else if (age === '1') {
            return {
              value: age,
              label: translate('cmp-booking-mask-label-infant-seat', '0-1 Infant in seat')
            };
          } else {
            return {
              value: age,
              label: age
            };
          }
        } else {
          return {
            value: age,
            label: age
          };
        }
      });
    return (
      <Stack gap="1">
        <Text variant="fontSize5">
          {translate(`cmp-label-age-${config.name}`, `Ages ${config.name}`)}
        </Text>
        <Inline alignY="center" align="start" gap={2} sx={styles.grow} childrenBottomMargin>
          {ages.map((age, index) => {
            return (
              <div>
                <div id={`screenReaderMessage-${id}-${index}`} hidden>
                  {`${translate('cmp-booking-selected-age-message', 'Selected age')} ${
                    ages[index]
                  }`}
                </div>
                <Listbox
                  portal
                  ariaLabelledBy={`screenReaderMessage-${id}-${index}`}
                  label={translate(
                    `cmp-label-age-${config.name}-select`,
                    `Select age ${config.name}`
                  )}
                  options={ageRanges}
                  defaultValue={`${age}`}
                  key={index}
                  onChange={(value) => {
                    props.onChange?.(index, Number(value));
                  }}
                  onClick={() => props.doNotClosePopup?.()}
                  filterContentRef={props.filterContentRef}
                />
              </div>
            );
          })}
        </Inline>
      </Stack>
    );
  }
  return null;
}
